stateProviders.push({
    name: 'schoolside.settings.account.financialAidYear',
    url: '/financialAidYear',
    templateUrl: 'fast/submodules/schoolside/settings/accountSettings/financialAidYear/partials/financialAidYear.html?v=' + versionNo,
    controller: 'FinancialAidYearController',
    resolve: {
        wolf: function(ModelService)
        {
            return ModelService.helpSystem.resolveData('?script=scForYset');
        },
        help: function(HelpSystemModelService)
        {
            return HelpSystemModelService.get('?script=scForYset')
        },
        school: function(SchoolModelService, authServiceFactory)
        {
            return SchoolModelService.get(authServiceFactory.getAuth().schoolID);
        }
    }
});